import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { AiFillCheckCircle } from 'react-icons/ai';
import { ICourses, ILessons, ISidebar } from './interfaces';
import { LessonNav, CourseNav, CourseMenu } from './styles';
import { useVideo } from '../../hooks/Video';

const Sidebar: React.FC<ISidebar> = ({ courses }) => {
  const { openVideo, openCategory, videoStatus, setChecked } = useVideo();
  const [active, setActive] = useState(0);

  const lessonsList = (
    coursesItems: Array<ICourses>,
    courseIndex: number,
    lessons: Array<ILessons>,
  ): JSX.Element[] => {
    const response = lessons.map((lesson, index) => {
      return (
        <LessonNav
          key={`sidebarLesson${lesson.id}`}
          onClick={() => openVideo(coursesItems, courseIndex, index)}
          className="lesson"
        >
          {' '}
          <div className="text">
            {' '}
            {lesson.title}
            <p>{lesson.release_date_formatted}</p>
          </div>
        </LessonNav>
      );
    });
    return response;
  };

  const changeActive = index => {
    index === active ? setActive(-1) : setActive(index);
  };

  const coursesList = (coursesItems: Array<ICourses>): JSX.Element[] => {
    const response = coursesItems.map((course, index) => {
      return (
        <CourseMenu key={`sidebarCourse${course.id}`} active={index === active}>
          <CourseNav
            onClick={() => {
              changeActive(index);
              openCategory(index, 0);
            }}
          >
            <div>
              <div className="menuCounter">{course.lessons.length}</div>
              {course.title}
            </div>
            <FiChevronDown />
          </CourseNav>
          {lessonsList(coursesItems, index, course.lessons)}
        </CourseMenu>
      );
    });
    return response;
  };

  return <>{coursesList(courses)}</>;
};

export default Sidebar;
